import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { ReactComponent as Logo } from '../../censuszen-logo.svg';
import NavTabs from './NavTabs';
import AvatarMenu from './AvatarMenu';
import CaseSubBar from './CaseSubBar';
import MobileNavMenu from './MobileNavMenu';
import BillingBanner from '../billing/BillingBanner';
import '../../styles/MenuBar.css';

export default function MenuBar() {
    const { user } = useAuth();

    return (
        <>
            <div className="menu-bar">
                <div className="menu-left">
                    <Link to="/" className="menu-logo-link" aria-label="CensusZen home">
                        <Logo className="menu-logo" />
                    </Link>
                    {user && <NavTabs />}
                    {user && <MobileNavMenu />}
                </div>
                <div className="menu-right">
                    {user && <AvatarMenu />}
                </div>
            </div>
            <CaseSubBar />
            <BillingBanner />
        </>
    );
}
